import React from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col
} from 'reactstrap';
import ReactLoader from 'components/Loader';

const AssociationConfirmationModal = ({
  isOpen,
  onClose,
  onFinalize,
  isProcessing,
  formType,
  selectedLeads,
  selectedOpportunities,
  selectedLeadsData,
  selectedOpportunitiesData
}) => {
  const getTitle = () => {
    if (formType === 'associateLeads') {
      return 'Lead selecionado';
    } else if (formType === 'associateOpportunities') {
      return 'Oportunidade Selecionada';
    }
    return 'Confirmar Associação';
  };

  const getMessage = () => {
    if (formType === 'associateLeads') {
      return `${selectedLeads.length} lead(s) selecionado(s). Deseja finalizar a associação?`;
    } else if (formType === 'associateOpportunities') {
      return `${selectedOpportunities.length} oportunidade(s) selecionada(s). Deseja finalizar a associação?`;
    }
    return 'Confirme sua escolha.';
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="md" centered>
      <ModalHeader toggle={onClose}>{getTitle()}</ModalHeader>
      <ModalBody>
        <div className="text-center">
          <p>{getMessage()}</p>

          {selectedLeads.length > 0 && (
            <div className="mb-3">
              <strong>Lead selecionado:</strong>
              <div className="mt-2">
                {selectedLeadsData.length > 0 ? (
                  selectedLeadsData.map((lead) => (
                    <div key={lead.id} className="text-muted small">
                      • {lead.name || 'Nome não informado'}
                    </div>
                  ))
                ) : (
                  <div className="text-muted small">
                    {selectedLeads.length} lead(s) selecionado(s)
                  </div>
                )}
              </div>
            </div>
          )}

          {selectedOpportunities.length > 0 && (
            <div className="mb-3">
              <strong>Oportunidade Selecionada:</strong>
              <div className="mt-2">
                {selectedOpportunitiesData.length > 0 ? (
                  selectedOpportunitiesData.map((opportunity) => (
                    <div key={opportunity.id} className="text-muted small">
                      •{' '}
                      {opportunity.title ||
                        opportunity.name ||
                        'Título não informado'}
                    </div>
                  ))
                ) : (
                  <div className="text-muted small">
                    {selectedOpportunities.length} oportunidade(s)
                    selecionada(s)
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <Row className="w-100">
          <Col xs={12} md={6} className="mb-2 mb-md-0">
            <Button
              color="secondary"
              size="sm"
              onClick={onClose}
              disabled={isProcessing}
              block
            >
              Cancelar
            </Button>
          </Col>
          <Col xs={12} md={6}>
            <Button
              color="success"
              size="sm"
              onClick={onFinalize}
              disabled={
                isProcessing ||
                (selectedLeads.length === 0 &&
                  selectedOpportunities.length === 0)
              }
              block
            >
              {isProcessing ? (
                <>
                  <ReactLoader width="16px" height="16px" />
                  <span className="ms-1">Finalizando...</span>
                </>
              ) : (
                'Finalizar Associação'
              )}
            </Button>
          </Col>
        </Row>
      </ModalFooter>
    </Modal>
  );
};

export default AssociationConfirmationModal;
